/**
 * @module Dropdown
 * @description
 */
import React, { FC, useState } from 'react';
import styles from './styles/Dropdown.module.css';
import Link from 'next/link';

interface Props {
  title: JSX.Element;
  menu: JSX.Element[];
  className?: string;
  ariaLabel: string;
}

const Dropdown: FC<Props> = ( { ...props } ) => {
  const {
    title,
    menu,
    className = '',
    ariaLabel
  } = props;

  return (
    <ul className={ `${ styles.dropdown } ${ className }` } aria-label={ ariaLabel }>
      { title }
      <ul className={ `${ styles.dropdown_menu } ${ className }` } >
        { menu }
      </ul>
    </ul>
  )
};

Dropdown.displayName = 'Dropdown';

export default Dropdown;
